module.exports = __webpack_public_path__ + "static/img/swhy.3b1a721.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/swhy.png
// module id = aRdv
// module chunks = 3